import { gql } from "app/graphql";


export const CREATE_USER_DEACTIVATED_NOTIFICATION = gql(`
    mutation CreateUserDeactivatedNotification($userId: Int!){
        notifications {
            events {
                userDeactivated(userId: $userId) {
                    success
                }
            }
        }
    }
`);

export const CREATE_CUSTOMER_INVITED_CHILD_CUSTOMER_NOTIFICATION = gql(`
    mutation CreateCustomerInvitedChildCustomerNotification($input: CustomerInvitedChildCustomerNotificationInput!){
        notifications {
            events {
                customerInvitedChildCustomerNotification(input: $input) {
                    success
                }
            }
        }
    }
`);

export const CREATE_PRIMARY_CUSTOMER_REGISTERED_NOTIFICATION = gql(`
    mutation CreatePrimaryCustomerRegisteredNotification($input: PrimaryCustomerRegisteredNotificationInput!){
        notifications {
            events {
                primaryCustomerRegisteredNotification(input: $input) {
                    success
                }
            }
        }
    }
`);

export const CREATE_CHILD_CUSTOMER_REGISTERED_NOTIFICATION = gql(`
    mutation CreateChildCustomerRegisteredNotification($input: ChildCustomerRegisteredNotificationInput!){
        notifications {
            events {
                childCustomerRegisteredNotification(input: $input) {
                    success
                }
            }
        }
    }
`);
